/**
 * Shared error display for every step-up auth phase.
 *
 * Uses ss-ui-client's templated form (`An error occurred {message}. Code: {code}`)
 * rather than sslite's raw `err.message` — support reps rely on the code being visible.
 * Replaces the `@deprecated` `BannerMessageV2` from
 * ss-ui-client/src/global/step-up-authentication/phases/components/error-banner.jsx
 */

import { FormattedMessage } from 'react-intl';

import { AlertBanner } from '../../components/alert-banner';
import { mfaMessages } from '../mfa-messages';

import type { AlertBannerStatus } from '../../components/alert-banner';

/**
 * `AlertBanner` has no `'error'` status — `'alert'` is its red/error status
 * (`faCircleExclamation` + `--adl-status-alert-*`).
 */
const ALERT_BANNER_ERROR_STATUS: AlertBannerStatus = 'alert';

export type MfaErrorBannerProps = {
  message: string;
  code?: string;
};

export const MfaErrorBanner = ({ message, code = '' }: MfaErrorBannerProps) => {
  const description = <FormattedMessage {...mfaMessages.errorMessage} values={{ code, message }} />;

  return <AlertBanner description={description} status={ALERT_BANNER_ERROR_STATUS} />;
};
